import { render, staticRenderFns } from "./DocumentPopover.vue?vue&type=template&id=70ee130a&scoped=true"
import script from "./DocumentPopover.vue?vue&type=script&lang=ts"
export * from "./DocumentPopover.vue?vue&type=script&lang=ts"
import style0 from "./DocumentPopover.vue?vue&type=style&index=0&id=70ee130a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee130a",
  null
  
)

export default component.exports